<app-advanced-form [config]="advancedFormConfig$ | async"
                   (events)="onAdvancedFormEvents($event)"
                   [mmTestId]="'EDIT_BUSINESS_INFO_PAGE.FORM'"></app-advanced-form>
